import gql from 'graphql-tag';

export const LabelsQuery = gql`
	query OnboardingEditorLabelsQuery($contentId: ID!, $status: [String]) {
		content(id: $contentId, status: $status) {
			nodes {
				id
				labels {
					nodes {
						id
						label
					}
				}
			}
		}
	}
`;
